import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-input-toggle',
  templateUrl: './app-input-toggle.component.html',
  styleUrls: ['./app-input-toggle.component.scss']
})
export class AppInputToggleComponent implements OnInit {
  private static count = 0;
  @Input() @Output() checked = false;
  @Input() disabled = false;
  @Input() label = '';
  @Input() size = 'md';
  @Input() outline = true;
  @Input() bgColor = 'bg-primary';
  @Input() bgOffColor = 'bg-white';
  @Output() checkedChange = new EventEmitter();
  id: string;
  focus;

  constructor() { }

  ngOnInit() {
    this.id = 'app-input-toggle-' + AppInputToggleComponent.count++;
  }

  toggle() {
    if (this.disabled) { return; }
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }

}
